export default () => ({
  page: 0,

  mouseEnter(e) {
    const index = e ? e.target.dataset.index : this.$el.dataset.index
    const elements = document.querySelectorAll("[data-index='" + index + "']");
    console.log(elements);
    elements.forEach((element) => {
      element.classList.add('active');
    })
  },

  mouseLeave(e) {
    const index = e ? e.target.dataset.index : this.$el.dataset.index
    const elements = document.querySelectorAll("[data-index='" + index + "']");
    elements.forEach((element) => {
      if (element.classList.contains('active')) {
        element.classList.remove('active');
      }
    })
  },


  init() {
    const items = document.querySelectorAll('.blueprint__floor__hover__item');
    items.forEach((item) => {
      item.addEventListener('mouseenter', this.mouseEnter);
      item.addEventListener('mouseleave', this.mouseLeave);
    })
  },
});
